import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "px-3 py-4 w-100",
  id: "select-pm-container"
}

import BalancePaymentItem from '@/components/BalancePaymentItem.vue';
import CreditCardPaymentItem from '@/components/CreditCardPaymentItem.vue';
import { EOffcanvasPage } from '@/components/Offcanvas/canvas.pages';
import useOffCanvas from '@/components/Offcanvas/useOffCanvas';
import PaymentSelectionItem from '@/components/PaymentSelectionItem.vue';
import useCards from '@/composables/useCards';
import usePayment from '@/composables/usePayment';
import useToast from '@/composables/useToast';
import useUser from '@/composables/useUser';
import { EPaymentType } from '@/enums';
import { onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentMethods',
  setup(__props) {

const {
  currentPaymentMethod,
  currentBalance,
  savePaymentMethod,
} = usePayment()

const { getCards, lastSelectedCard } = useCards()
const {toastError} =useToast()
const { syncUser } = useUser()

const selectedMethod = ref<EPaymentType | null>()
if (currentPaymentMethod.value) {
  selectedMethod.value = currentPaymentMethod.value.payment_type
}
const { navigateCanvas, closeCanvas } = useOffCanvas()

const handleBalanceSelected = () => {
  if (currentBalance.value > 0) {
    selectedMethod.value = EPaymentType.balance
  }
}
const handleCardSelected = () => {
  if (lastSelectedCard.value) {
    selectedMethod.value = EPaymentType.credit_card
  }
}

const handleAddOrUpdateCard = () => {
  if (!currentPaymentMethod.value) {
    return goToAddCards()
  }
  goToCardsList()
}

const goToAddCards = () => {
  navigateCanvas(EOffcanvasPage.add_card)
}
const goToCardsList = () => {
  navigateCanvas(EOffcanvasPage.credit_cards)
}
const goToAddBalance = () => {
  navigateCanvas(EOffcanvasPage.add_balance)
}

const handlePaymentConfirmed = () => {
  if (!selectedMethod.value) {
    toastError('Selecione um  método de pagamento')
    return false
  }
  if (selectedMethod.value == EPaymentType.balance) {
    savePaymentMethod({ payment_type: EPaymentType.balance, card_info: null })
  } else {
    savePaymentMethod({ payment_type: EPaymentType.credit_card, card_info: lastSelectedCard.value })
  }
  closeCanvas()
}

onMounted(() => {
  syncUser()
  getCards()
})


return (_ctx: any,_cache: any) => {
  const _component_SubmitBtn = _resolveComponent("SubmitBtn")!
  const _component_AppContainer = _resolveComponent("AppContainer")!

  return (_openBlock(), _createBlock(_component_AppContainer, { id: "app-payment-methods" }, {
    default: _withCtx(() => [
      _createVNode(PaymentSelectionItem, {
        id: "pm-balance-selection",
        onClick: handleBalanceSelected,
        selected: selectedMethod.value == _unref(EPaymentType).balance
      }, {
        default: _withCtx(() => [
          _createVNode(BalancePaymentItem, { balance: _unref(currentBalance) }, null, 8, ["balance"])
        ]),
        _: 1
      }, 8, ["selected"]),
      _createElementVNode("button", {
        onClick: goToAddBalance,
        id: "add-pix-balance",
        class: "btn btn-link btn-sm text-primary mb-4 ps-0"
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("i", { class: "fas fa-plus me-2" }, null, -1),
        _createTextVNode(" Adicionar saldo com pix")
      ])),
      _createVNode(PaymentSelectionItem, {
        id: "pm-card-selection",
        onClick: handleCardSelected,
        selected: selectedMethod.value == _unref(EPaymentType).credit_card
      }, {
        default: _withCtx(() => [
          _createVNode(CreditCardPaymentItem, { info: _unref(lastSelectedCard) }, null, 8, ["info"])
        ]),
        _: 1
      }, 8, ["selected"]),
      _createElementVNode("button", {
        onClick: handleAddOrUpdateCard,
        id: "add-update-card",
        class: "btn btn-link btn-sm text-primary mb-2 ps-0"
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "fas fa-plus me-2" }, null, -1),
        _createTextVNode(" Adicionar ou alterar ")
      ])),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_SubmitBtn, {
          title: "Selecionar",
          class: "w-100",
          onClick: handlePaymentConfirmed
        })
      ])
    ]),
    _: 1
  }))
}
}

})